<template>
  <el-dialog
    class="rank-editor"
    :visible="rankEditorVisible"
    @close="closeEditor"
    width="640px"
  >
    <el-form
      :model="rankForm"
      :rules="rules"
      ref="rankForm"
      label-width="100px"
      class="ranks-ruleForm"
    >
      <el-form-item label="分類" prop="type">
        <el-radio-group v-model="rankForm.type">
          <el-radio-button label="examination">升國中</el-radio-button>
          <el-radio-button label="special-class">升高中</el-radio-button>
          <el-radio-button label="university">升大學</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-select
          v-model="rankForm.year"
          placeholder="選擇年份"
          no-data-text="無資料"
        >
          <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="標題" prop="title">
        <el-input class="title-input" v-model="rankForm.title"></el-input>
      </el-form-item>
      <el-form-item
        v-for="(name, index) in rankForm.names"
        :label="'姓名' + (index + 1)"
        :key="name.key"
        :prop="'names.' + index + '.value'"
        :rules="{
          required: true,
          message: '請輸入姓名',
          trigger: 'blur',
        }"
      >
        <el-input class="name-input" v-model="name.value"></el-input>
        <el-button
          type="success"
          v-if="index == rankForm.names.length - 1"
          @click.prevent="addName"
          >新增+</el-button
        >
        <el-button
          @click.prevent="removeName(name)"
          v-if="rankForm.names.length > 1"
          >删除</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEditor">取 消</el-button>
      <el-button type="primary" @click="confirm">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment';
// import _ from "lodash";

export default {
  props: ['rankEditorVisible', 'rankForm', 'isCreate'],
  data() {
    return {
      rules: {
        type: [{ required: true, message: '請選擇分類', trigger: 'blur' }],
        year: [{ required: true, message: '請選擇年份', trigger: 'blur' }],
        title: [{ required: true, message: '請輸入標題', trigger: 'blur' }],
      },
    };
  },
  computed: {
    yearOptions() {
      let nowYear = moment().format('YYYY');
      const countryYear = Number(nowYear) - 1911;
      let list = [];
      for (let i = countryYear; i >= 105; i--) {
        const item = {
          value: i,
        };
        list.push(item);
      }
      return list;
    },
  },
  methods: {
    confirm() {
      this.$refs['rankForm'].validate(async (valid) => {
        if (valid) {
          this.$emit('saveRank', this.rankForm);
        } else {
          return false;
        }
      });
    },
    closeEditor() {
      this.$emit('update:rankEditorVisible', false);
    },
    addName() {
      this.rankForm.names.push({ value: '', key: Date.now() });
    },
    removeName(item) {
      var index = this.rankForm.names.indexOf(item);
      if (index !== -1) {
        this.rankForm.names.splice(index, 1);
      }
    },
  },
  created() {},
  mounted() {},
  components: {},
};
</script>

<style lang="scss" scoped>
.title-input {
  width: 250px;
}

.name-input {
  width: 150px;
  margin-right: 10px;
}
</style>
